import { IBasicUtil, Role, RoleList } from "@/interfaces/IBasicUtil";
import { Ref } from "vue";
import { ActiveLoader, useLoading } from 'vue-loading-overlay'

export class BasicUtil implements IBasicUtil {

  private loading: ActiveLoader | undefined
  private loadingCount: number = 0

  public hasRole (roleStr: string, role: Role) {
    return roleStr.substr(role, 1) === "1"
  }

  public getRoleList(roleStr: string) {
    return {
      user: this.hasRole(roleStr, Role.User),
      finance: this.hasRole(roleStr, Role.Finance)
    }
  }

  private getRoleString(flg: boolean): string {
    return flg ? "1" : "0"
  }

  public setRoleList(roles: RoleList) {
    return this.getRoleString(roles.user) + this.getRoleString(roles.finance) + "000000"
  }

  public async showFullLoading() {
    if (this.loadingCount == 0) {
      const $loading = useLoading()
      this.loading = $loading.show({
        color: '#ccc',
        loader: 'bars',
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.3,
        zIndex: 999,
      });
    }
    this.loadingCount += 1
  }

  public async showLoading(component: any, isFullScreen: boolean) {
    if (this.loadingCount == 0) {
      const $loading = useLoading()
      this.loading = $loading.show({
        color: '#ccc',
        loader: 'bars',
        container: isFullScreen ? null : component.$refs.root,
        width: 64,
        height: 64,
        backgroundColor: '#ffffff',
        opacity: 0.3,
        zIndex: 999,
      });
    }
    this.loadingCount += 1
  }

  public async hideLoading() {
    this.loadingCount -= 1
    if (this.loadingCount == 0) {
      this.loading?.hide()
    }
  }

  public showToast(vm: any, message: string) {
    vm.$toast.show(message, {
      type: 'info',
      position: "top-right",
    }); 
  }
}